var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Form',{attrs:{"data":_vm.data,"readonly":_vm.readonly}})
}
var staticRenderFns = []

export { render, staticRenderFns }